import { RouteObject } from "react-router-dom";
import ProtectedOutlet from "components/ProtectedOutlet";
import { ClaimResource } from "types/claimTypes";

import QualificationList from "pages/QualificationsPage/QualificationList";
import QualificationDetails from "pages/QualificationsPage/QualificationDetails";
import QualificationSkus from "pages/QualificationsPage/QualificationSkus";

import LicenseList from "pages/LicensesPage/LicenseList";
import LicenseDetails from "pages/LicensesPage/LicenseDetails";

import RequirementSetDetails from "pages/RequirementSetsPage/RequirementSetDetails";
import RequirementDetails from "pages/RequirementsPage/RequirementDetails";

import RequirementAuthoring from "pages/RequirementAuthoringPage";

import LicensureBodyList from "pages/LicensureBodiesPage/LicensureBodyList";
import LicensureBodyDetails from "pages/LicensureBodiesPage/LicensureBodyDetails";
import LicensureBodySkus from "pages/LicensureBodiesPage/LicensureBodySkus";

import SubmissionAuthorityList from "pages/SubmissionAuthorityPage/SubmissionAuthorityList";
import SubmissionAuthorityDetails from "pages/SubmissionAuthorityPage/SubmissionAuthorityDetails";
import SubmissionAuthoritySkus from "pages/SubmissionAuthorityPage/SubmissionAuthoritySkus";

import AddCreditSubmissionReport from "pages/CreditSubmissionReportsPage/AddCreditSubmissionReport";
import PreviouslyExportedReports from "pages/CreditSubmissionReportsPage/PreviouslyExportedReports";

import AccreditationPage from "pages/AccreditationPage";

export const accreditationRoutes: RouteObject[] = [
  {
    element: <ProtectedOutlet claims={[ClaimResource.Qualifications]} />,
    children: [
      { path: "qualifications", element: <QualificationList /> },
      { path: "qualifications/-/:id", element: <QualificationDetails /> },
      { path: "qualifications/-/:id/skus", element: <QualificationSkus /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.Licenses]} />,
    children: [
      { path: "licenses", element: <LicenseList /> },
      { path: "licenses/-/:id", element: <LicenseDetails /> },
      { path: "licenses/-/:licenseId/author", element: <RequirementAuthoring /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.Licenses]} />,
    children: [
      { path: "requirement-sets/-/:id", element: <RequirementSetDetails /> },
      { path: "requirements/-/:id", element: <RequirementDetails /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.Licenses]} />,
    children: [
      { path: "licensure-bodies", element: <LicensureBodyList /> },
      { path: "licensure-bodies/-/:id", element: <LicensureBodyDetails /> },
      { path: "licensure-bodies/-/:id/skus", element: <LicensureBodySkus /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.Licenses]} />,
    children: [
      { path: "submission-authorities", element: <SubmissionAuthorityList /> },
      { path: "submission-authorities/-/:id", element: <SubmissionAuthorityDetails /> },
      { path: "submission-authorities/-/:id/skus", element: <SubmissionAuthoritySkus /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.SubmissionReport]} />,
    children: [
      { path: "credit-submission-reports", element: <PreviouslyExportedReports /> },
      { path: "credit-submission-reports/add", element: <AddCreditSubmissionReport /> },
    ],
  },
  { index: true, element: <AccreditationPage /> },
];
